// @flow

type T_Header = 'STATS' | 'CULTI' | 'MS' | 'SEN';


export function setHeaderExcel(workbook: Object, worksheet: Object, title: string, subtitle: string, which_header: T_Header): void {
  // FIXME: el parámetro 'subtitle' no se usa nunca
  
  // const myBase64Image = which_header === 'STATS' ? HEADER_STATS : (which_header === 'CULTI' ? HEADER_CULTI : HEADER_MS),
  //       headerImage = workbook.addImage({base64: myBase64Image, extension: 'png'});
  // 
  // worksheet.addImage(headerImage, 'A1:G2');
  
  const titleT = (which_header === 'STATS' ?
    'Estadísticas por elemento'
  : 
    (which_header === 'CULTI' ? 'Datos del Cultivable' 
    : 
    (which_header === 'MS' ? 'Datos de muestra de suelo' : 'Datos del sensor')
    )
  );
  
  const mergeT = (which_header === 'SEN' ?
    'A1:M2'
  : 'A1:G2'
  );
  
  const mergeST = (which_header === 'SEN' ?
    'A3:M4'
  : 'A3:G4'
  );
  
  worksheet.mergeCells(mergeT);
  worksheet.getCell('A1').value = titleT;
  worksheet.getCell('A1').font = {bold: true, color: {argb: 'FFFFFFFF'}};
  worksheet.getCell('A1').alignment = {vertical: 'middle', horizontal: 'center'};
  worksheet.getCell('A1').fill = {type: 'pattern', pattern: 'solid', fgColor: {argb:'FFe00109'}, bgColor: {argb:'FFe00109'}};
  worksheet.getRow(1).height = 25;
  worksheet.getRow(2).height = 25;
  worksheet.mergeCells(mergeST);
  worksheet.getCell('A3').value = title;
  worksheet.getCell('A3').font = {bold: true, color: {argb: 'FF808080'}};
  worksheet.getCell('A3').alignment = {vertical: 'middle', horizontal: 'center'};
  worksheet.getRow(3).height = 25;
  worksheet.getRow(4).height = 25;
};



export function setTitlesStyles(worksheet: Object, num: number, has_many_rows: boolean): void {
  const row = worksheet.getRow(num);
  
  row.font = {
    bold: true,
    color: {argb: 'FFFFFFFF'}
  };
  
  row.alignment = {vertical: 'middle', horizontal: 'center', wrapText: false};
  row.height = 25;
  
  row.eachCell((cell, rowNumber) => {
    cell.border = {
      top: has_many_rows ? {style: 'thin', color: {argb:'FF2A2A2A'}} : {},
      bottom: {style: 'thin', color: {argb:'FF2A2A2A'}},
    };
    
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb:'FFA6A6A6'},
      bgColor: {argb:'FFA6A6A6'}
    };
  });
};



// WEBPACK FOOTER //
// ./src/imgExcel.js